import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@ordr-as/icons'

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    splits: any[]
    label: string
}

const ListAccordion = ({ splits, label }: Props) => {
    return (
        <Disclosure>
            {({ open }) => (
                <div className="my-2">
                    <Disclosure.Button className="font-semibold flex justify-between w-full items-center">
                        <span className={`${open ? 'text-brand-primary' : ''} transition-colors`}>{label}</span>{' '}
                        <ChevronDownIcon
                            className={`${open ? 'transform rotate-180' : ''} transition-transform text-brand-primary`}
                        />
                    </Disclosure.Button>
                    <Disclosure.Panel>
                        {splits ? (
                            splits.map((split, idx) => (
                                <div key={idx}>
                                    <div className="border-l-2 border-brand-primary ml-2 mt-2 mb-4 pl-2">
                                        {
                                            <>
                                                {Object.entries(split).map(([key, value], idx) => (
                                                    <div key={idx} className="flex justify-between my-2">
                                                        <div className="font-semibold">{key}</div>
                                                        <div>{String(value)}</div>
                                                    </div>
                                                ))}
                                            </>
                                        }
                                    </div>
                                    {idx !== splits.length - 1 && <hr className="border-grey-lightest pb-2 ml-4"></hr>}
                                </div>
                            ))
                        ) : (
                            <div className="ml-3 italic">No values</div>
                        )}
                    </Disclosure.Panel>
                </div>
            )}
        </Disclosure>
    )
}

export default ListAccordion
